import mapboxgl from "mapbox-gl";

import { MAPBOX_KEY } from "@/config";

const DEFAULT_OPTIONS = {
  center: [-77.032, 38.913],
  zoom: 10,
};

export const createMap = (containerRef, options = DEFAULT_OPTIONS) => {
  mapboxgl.accessToken = MAPBOX_KEY;
  return new mapboxgl.Map({
    container: containerRef,
    ...options,
  });
};

export const addMarker = (map, coordinate) => {
  const el = document.createElement("div");
  el.className = "marker";
  new mapboxgl.Marker(el).setLngLat(coordinate).addTo(map);
};
